import { z } from 'zod';
import { ASSIGNABLE_DOCUMENT_TYPES } from '@/features/document-templates/types/documentTemplates.types';

export const generateDocumentSchema = z.object({
    documentType: z.enum(ASSIGNABLE_DOCUMENT_TYPES, { message: 'Choose a document' }),
});

export type GenerateDocumentFormInput = z.input<typeof generateDocumentSchema>;
export type GenerateDocumentFormValues = z.output<typeof generateDocumentSchema>;
